/**
 * The attributes each grid layer can be colored by ("Color by") and raised by
 * in the 3D view ("Height attribute"), keyed by the section id the layer's
 * primary-key atom (primaryKeyForSection) and legend use. The Map Controls
 * panel reads the entry for whichever section is on the map.
 */
import { POST_ATTRIBUTES } from '../Post/PostLayer';
import { POPULATION_ATTRIBUTES } from '../Incident/PopulationLayer';
import { RESIDENTIAL_ATTRIBUTES } from '../Incident/ResidentialLayer';
import { NON_RESIDENTIAL_ATTRIBUTES } from '../Incident/NonResidentialLayer';
import { COMMUNICATIONS_ATTRIBUTES } from '../Incident/CommunicationsLayer';
import { DECLARATIONS_ATTRIBUTES } from '../Incident/DeclarationsLayer';

export type AttributeOption = { key: string; label: string };

export type AttributeOptions = {
  /** What the grid cells can be colored by. */
  primary: AttributeOption[];
  /** What the grid cells can be raised by in the 3D view. */
  elevation: AttributeOption[];
};

const ATTRIBUTES_BY_SECTION: Record<string, AttributeOptions> = {
  'wow-post': POST_ATTRIBUTES,
  'nifc-post': POST_ATTRIBUTES,
  'canopy-post': POST_ATTRIBUTES,
  population: POPULATION_ATTRIBUTES,
  residential: RESIDENTIAL_ATTRIBUTES,
  nonResidentialStructures: NON_RESIDENTIAL_ATTRIBUTES,
  communications: COMMUNICATIONS_ATTRIBUTES,
  declarations: DECLARATIONS_ATTRIBUTES,
};

/** The attribute options for a section, or null when its layer has none. */
export const attributeOptionsFor = (sectionId: string): AttributeOptions | null =>
  Object.hasOwn(ATTRIBUTES_BY_SECTION, sectionId) ? ATTRIBUTES_BY_SECTION[sectionId] : null;
